const createMembersStore = (set) => ({
  membersList: {},
  membersLoading: false,
  showAddMember: false,

  setMembersList: (groupId, list) =>
    set((state) => ({
      members: {
        ...state.members,
        membersList: {
          ...state.members.membersList,
          [groupId]: list,
        },
      },
    })),

  setMembersLoading: (membersLoading) =>
    set((state) => ({
      members: {
        ...state.members,
        membersLoading,
      },
    })),

  setShowAddMember: (showAddMember) =>
    set((state) => ({
      members: {
        ...state.members,
        showAddMember,
      },
    })),

  updateMember: (groupId, memberId, updatedData) =>
    set((state) => {
      const currentMembers = state.members.membersList[groupId] || [];
      const updatedMembers = currentMembers.map((member) =>
        member.id === memberId ? { ...member, ...updatedData } : member
      );

      return {
        members: {
          ...state.members,
          membersList: {
            ...state.members.membersList,
            [groupId]: updatedMembers,
          },
        },
      };
    }),

  reset: () =>
    set((state) => ({
      members: {
        ...state.members,
        membersList: {},
      },
    })),
});

export default createMembersStore;
